import $ from "jquery";
import "select2";

export function initializeSelect2() {
  document.querySelectorAll(".select-tags").forEach((element) => {
    const $element = $(element);

    if ($element.hasClass("select2-hidden-accessible")) return;

    $element.select2({
      allowClear: true,
      placeholder: "",
      tags: $element.data("tags-names"),
      tokenSeparators: [","],
    });
  });

  document.querySelectorAll("select, input.select[data-remote]").forEach((element) => {
    const $element = $(element);

    if ($element.hasClass("select2-hidden-accessible")) return;

    const selected = $element.data("selected");

    if (Array.isArray(selected)) {
      selected.forEach((item) => {
        const option = new Option(item.text, item.id, true, true);
        $element.append(option);
      });
      $element.trigger("change");
    } else if (selected?.id) {
      const option = new Option(selected.text, selected.id, true, true);
      $element.append(option).trigger("change");
    }

    let options = {
      allowClear: $element.data("allowClear") !== undefined ? $element.data("allowClear") : true,
      placeholder: " ",
    };

    if ($element.hasClass("select-long")) {
      options.minimumInputLength = 3;
    }

    if ($element.data("remote")) {
      options = {
        ...options,
        minimumInputLength: 2,
        ajax: {
          url: $element.data("remote"),
          dataType: "json",
          delay: 250,
          data: (params) => ({ query: params.term }),
          processResults: (data) => {
            const valueAttr = $element.data("value-attribute");
            const results = data.records.map((result) => {
              const source = result._source || result;
              return {
                id: source.id,
                text: source[valueAttr],
              };
            });
            return { results };
          },
          cache: false,
        },
      };
    }

    $element.select2(options);
  });
}
